module.exports = __webpack_public_path__ + "fonts/Lato-300-latin2.dc76fa2.woff2";